var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"iconContent",staticStyle:{"display":"visible"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.iconContent)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }